export default __webpack_public_path__ + "db12265fe83a74315e5c4f48b0c72ec5.png";